<template>
  <div>
    <highlighted-text
      v-if="noEncoding"
      :value="literal.value"
      :highlights="highlights"
    ></highlighted-text>

    <div v-if="isGeocoord">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span v-on="on" v-bind="attrs">
            <!-- display: block -->
            <span class="text-caption">
              lat
              <highlighted-text
                class="text-body-1"
                :value="latitude"
                :highlights="highlights"
              ></highlighted-text
              >&nbsp;
            </span>
            <!-- display: block -->
            <span class="text-caption">
              long
              <highlighted-text
                class="text-body-1"
                :value="longitude"
                :highlights="highlights"
              ></highlighted-text>
            </span>
          </span> </template
        ><span>{{ 'raw ' + literal.value }}</span></v-tooltip
      >
    </div>
  </div>
</template>

<script>
import HighlightedText from './HighlightedText.vue'

import { Literal } from '@/rec-cache/rec-cache-types'

export default {
  components: { HighlightedText },
  props: {
    literal: {
      type: Object,
      default: () => {
        return new Literal()
      },
    },
    highlights: {
      type: [String, Array],
      default: () => {
        return []
      },
    },
    encoding: {
      type: String,
      default: 'no-encoding',
    },
  },
  computed: {
    noEncoding: function () {
      return this.encoding == 'no-encoding'
    },
    isGeocoord: function () {
      return this.encoding == 'geocoord'
    },
    latitude: function () {
      const [, lat] = JSON.parse(this.literal.value)
      return lat.toString()
    },
    longitude: function () {
      const [lon] = JSON.parse(this.literal.value)
      return lon.toString()
    },
  },
  mounted() {
    // console.log('components.literal-value.mounted', this.literal)
  },
}
</script>
